import {getAdjustedRange} from "./editFileUtils.ts";

export const sendEditFileArgs = (llmRequestRefs: any, finishedToolCall: any, environmentObjRef: any, settingsObjRef: any) => {
    const {adjustedStart, adjustedEnd} = getAdjustedRange(llmRequestRefs.current.additionalContext.toolCallAdjustments, finishedToolCall.args.filePath, finishedToolCall.args.startLine, finishedToolCall.args.endLine);

    const args = {
        functionName: "editFile",
        data: [{
            toolCallId: finishedToolCall.id,
            filePath: finishedToolCall.args.filePath,
            startLine: adjustedStart.toString(),
            endLine: adjustedEnd.toString(),
            newContents: finishedToolCall.args.newContents ?? "",
            scrapeErrors: (settingsObjRef?.current?.scrapeErrors ?? false).toString(),
            scrapeWarnings: (settingsObjRef?.current?.scrapeWarnings ?? false).toString()
        }]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendCreateFileArgs = (finishedToolCall: any, environmentObjRef: any, settingsObjRef: any) => {
    const args = {
        functionName: "createFile",
        data: [{
            toolCallId: finishedToolCall.id,
            filePath: finishedToolCall.args.filePath,
            newContents: finishedToolCall.args.newContents ?? "",
            scrapeErrors: (settingsObjRef?.current?.scrapeErrors ?? false).toString(),
            scrapeWarnings: (settingsObjRef?.current?.scrapeWarnings ?? false).toString()
        }]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendDeleteFileArgs = (finishedToolCall: any, environmentObjRef: any) => {
    const args = {
        functionName: "deleteFile",
        data: [{toolCallId: finishedToolCall.id, filePath: finishedToolCall.args.filePath}]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendMoveFileArgs = (finishedToolCall: any, environmentObjRef: any, settingsObjRef: any) => {
    const args = {
        functionName: "moveFile",
        data: [{
            toolCallId: finishedToolCall.id,
            filePath: finishedToolCall.args.filePath,
            newFilePath: finishedToolCall.args.newFilePath,
            scrapeErrors: (settingsObjRef?.current?.scrapeErrors ?? false).toString(),
            scrapeWarnings: (settingsObjRef?.current?.scrapeWarnings ?? false).toString()
        }]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendRunTerminalCommandArgs = (finishedToolCall: any, environmentObjRef: any) => {
    const args = {
        functionName: "runTerminalCommand",
        data: [{toolCallId: finishedToolCall.id, command: finishedToolCall.args.command, runsIndefinitely: (finishedToolCall.args.runsIndefinitely ?? false).toString()}]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendSearchCodebaseCommandArgs = (finishedToolCall: any, environmentObjRef: any, serverResponseResults: any) => {
    const args = {
        functionName: "searchCodebase",
        data: [{toolCallId: finishedToolCall.id, isGatherContext: (finishedToolCall.args.isGatherContext ?? false).toString(), selectedFiles: JSON.stringify(serverResponseResults.filesToPull ?? [])}]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendGrepCodebaseCommandArgs = (finishedToolCall: any, environmentObjRef: any) => {
    const args = {
        functionName: "grepCodebase",
        data: [{toolCallId: finishedToolCall.id, input: finishedToolCall.args.input, type: finishedToolCall.args.type ?? "regex", isGatherContext: (finishedToolCall.args.isGatherContext ?? false).toString()}]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendOpenFileCommandArgs = (finishedToolCall: any, environmentObjRef: any) => {
    const args = {
        functionName: "openFileInIde",
        data: [{toolCallId: finishedToolCall.id, filePath: finishedToolCall.args.filePath, isGatherContext: (finishedToolCall.args.isGatherContext ?? false).toString()}]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendViewDirectoryCommandArgs = (finishedToolCall: any, environmentObjRef: any) => {
    const args = {
        functionName: "viewDirectory",
        data: [{toolCallId: finishedToolCall.id, dirName: finishedToolCall.args.dirName, isGatherContext: (finishedToolCall.args.isGatherContext ?? false).toString() }]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}

export const sendReviewChangesCommandArgs = (finishedToolCall: any, environmentObjRef: any, dynamicStateObjRef: any) => {
    // Get all file paths from the unreviewed file tracker (files that have been modified)
    const filePaths = Object.keys(dynamicStateObjRef.current.unreviewedFileTracker || {});

    const args = {
        functionName: "reviewChanges",
        data: [{toolCallId: finishedToolCall.id, filePaths: JSON.stringify(filePaths ?? []), task: finishedToolCall.args.task}]
    };

    if (environmentObjRef.current.environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
    else if (environmentObjRef.current.environment === "vscode") environmentObjRef.current.vscode.postMessage(args);
}
